"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Dom = require("../utils/Dom");

var _underscore = require("../utils/underscore");

var _passthroughProps = _interopRequireDefault(require("../utils/propTypes/passthroughProps"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Functions = require("../core/Functions");

var _ReactNodes = require("../core/ReactNodes");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _decorators = require("../utils/propTypes/decorators");

var _UIAbstractDropdown = _interopRequireDefault(require("./abstract/UIAbstractDropdown"));

var _UIAbstractDropdownWithSearchbox = _interopRequireDefault(require("./abstract/UIAbstractDropdownWithSearchbox"));

var _UIPopover = _interopRequireDefault(require("../tooltip/UIPopover"));

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var USE_CLASSES = {
  list: 'private-dropdown--list',
  unstyled: ''
};

var UIDropdown = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIDropdown, _PureComponent);

  function UIDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIDropdown).call(this, props));

    _this.menuRefCallback = function (ref) {
      _this._menuEl = ref;
      if (ref) _this.checkForSearchbox();
    };

    _this.handleOpenComplete = function () {
      var _this$props = _this.props,
          onOpenComplete = _this$props.onOpenComplete,
          use = _this$props.use;

      if (!(_this.state.hasSearchbox || use === 'unstyled')) {
        // Move the focus to the first menu item (<li>).
        _this.focusNextMenuItem();
      }

      if (onOpenComplete) onOpenComplete();
    };

    _this.handleMenuClick = function (evt) {
      var _this$props2 = _this.props,
          closeOnMenuClick = _this$props2.closeOnMenuClick,
          onOpenChange = _this$props2.onOpenChange;

      if (closeOnMenuClick) {
        var target = evt.target;
        var iterableTarget = target;
        if (!(0, _Dom.closest)(target, '[data-dropdown-menu]')) return; // Portals! #6595

        while (iterableTarget && !(0, _Dom.elementHasClass)(iterableTarget, 'private-dropdown') && iterableTarget.getAttribute('data-component-name') !== 'UIFileButton') {
          // Only close when clicking a `button` or `a` tag!
          if (['BUTTON', 'A'].includes(iterableTarget.nodeName) && !iterableTarget.disabled) {
            onOpenChange((0, _SyntheticEvent.default)(false));
            return;
          }

          iterableTarget = iterableTarget.parentElement;
        }
      }
    };

    _this.handleSearchChange = function () {
      _this.forceUpdate(); // Reposition the Tether after the search results flush to the DOM

    };

    _this.handleKeyDown = function (evt) {
      var key = evt.key;
      var _this$props3 = _this.props,
          onOpenChange = _this$props3.onOpenChange,
          open = _this$props3.open,
          use = _this$props3.use;
      if (!open) return;

      if (_this.state.hasSearchbox) {
        if (key === 'Enter') {
          onOpenChange((0, _SyntheticEvent.default)(false));
        }

        evt.stopPropagation();
        return;
      } // Move the focus to the next/prev menu item (<li>).


      if (use !== 'unstyled' && (key === 'ArrowDown' || key === 'ArrowUp')) {
        if (_this.focusNextMenuItem(key === 'ArrowUp')) {
          evt.preventDefault();
        }

        evt.stopPropagation();
      }
    };

    _this.renderContent = function () {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          Content = _this$props4.Content;
      var hasSearchbox = _this.state.hasSearchbox;
      var mutatedChildren = children;

      if (hasSearchbox && !Content) {
        mutatedChildren = _react.Children.map(children, function (child) {
          if ((0, _ReactNodes.nodeDisplayNameMatches)(child, /UITypeahead|UIGroupedTypeahead/)) {
            return _react.default.cloneElement(child, {
              autoFocus: _this._enableAutofocus ? true : child.props.autoFocus,
              onSearchChange: (0, _Functions.memoizedSequence)(child.props.onSearchChange, _this.handleSearchChange)
            });
          }

          return child;
        });
      }

      return _react.default.createElement("div", {
        "data-dropdown-menu": true,
        id: _this._id,
        onClick: _this.handleMenuClick,
        ref: _this.menuRefCallback,
        role: "presentation"
      }, Content ? _react.default.createElement(Content, null) : mutatedChildren);
    };

    _this.state = {
      hasSearchbox: false
    };
    _this._id = "dropdown-menu-" + (0, _underscore.uniqueId)();
    _this.popoverRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(UIDropdown, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Only autofocus when `open` prop goes from false => true
      if (!this.props.open && nextProps.open) {
        this._enableAutofocus = true;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkForSearchbox(); // Reposition the Tether, as the results list may have changed height.

      if (this.popoverRef.current) this.popoverRef.current.reposition();
    }
  }, {
    key: "checkForSearchbox",
    value: function checkForSearchbox() {
      // Check if we have a searchbox, as we may need to make the arrow color match.
      if (this._menuEl && document.body.contains(this._menuEl)) {
        var hasSearchbox = !!this._menuEl.querySelector('.private-typeahead:not(.hide-search)');

        if (this.state.hasSearchbox !== hasSearchbox) {
          this.setState({
            hasSearchbox: hasSearchbox
          });
        }
      }
    }
  }, {
    key: "focusNextMenuItem",
    value: function focusNextMenuItem() {
      var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var menu = document.getElementById(this._id);
      return (0, _Dom.moveFocusToNext)('li', menu, reverse);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          autoPlacement = _this$props5.autoPlacement,
          buttonClassName = _this$props5.buttonClassName,
          buttonText = _this$props5.buttonText,
          buttonUse = _this$props5.buttonUse,
          children = _this$props5.children,
          className = _this$props5.className,
          __closeOnMenuClick = _this$props5.closeOnMenuClick,
          __Content = _this$props5.Content,
          dropdownClassName = _this$props5.dropdownClassName,
          locked = _this$props5.locked,
          iconName = _this$props5.iconName,
          popoverProps = _this$props5.popoverProps,
          popoverRef = _this$props5.popoverRef,
          use = _this$props5.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["autoPlacement", "buttonClassName", "buttonText", "buttonUse", "children", "className", "closeOnMenuClick", "Content", "dropdownClassName", "locked", "iconName", "popoverProps", "popoverRef", "use"]);

      var containsFooter = _react.Children.toArray(children).some(function (child) {
        return (0, _ReactNodes.nodeDisplayNameMatches)(child, /UIDropdownFooter/);
      });

      var computedDropdownClassName = (0, _classnames.default)(className, dropdownClassName, USE_CLASSES[use], {
        'p-y-0': containsFooter
      });
      var defaultIcon = buttonText ? undefined : 'settings';
      return _react.default.createElement(_UIAbstractDropdownWithSearchbox.default, (0, _extends2.default)({}, rest, {
        autoPlacement: autoPlacement,
        buttonText: buttonText,
        buttonUse: buttonUse,
        className: buttonClassName,
        Content: this.renderContent,
        dropdownClassName: computedDropdownClassName,
        hasSearchbox: this.state.hasSearchbox,
        iconName: iconName !== undefined ? iconName : defaultIcon,
        locked: locked,
        onOpenComplete: this.handleOpenComplete,
        onKeyDown: this.handleKeyDown,
        popoverRef: popoverRef || this.popoverRef,
        popoverProps: popoverProps
      }), children);
    }
  }]);
  return UIDropdown;
}(_react.PureComponent);

UIDropdown.propTypes = (0, _extends2.default)({}, _UIAbstractDropdown.default.propTypes, {
  arrowColor: (0, _decorators.hidden)(_UIAbstractDropdown.default.propTypes.arrowColor),
  buttonClassName: _propTypes.default.string,
  buttonText: _UIAbstractDropdown.default.propTypes.buttonText,
  children: _UIAbstractDropdown.default.propTypes.children,
  closeOnMenuClick: _propTypes.default.bool.isRequired,
  iconName: _UIAbstractDropdown.default.propTypes.iconName,
  locked: _UIAbstractDropdown.default.propTypes.locked,
  onOpenChange: _UIAbstractDropdown.default.propTypes.onOpenChange,
  open: _UIAbstractDropdown.default.propTypes.open,
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS),
  popoverProps: (0, _passthroughProps.default)(_UIPopover.default),
  popoverRef: _refObject.default,
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES)).isRequired
});
UIDropdown.defaultProps = (0, _extends2.default)({}, _UIAbstractDropdown.default.defaultProps, {
  buttonUse: 'tertiary-light',
  closeOnMenuClick: true,
  menuWidth: 'auto',
  pinToConstraint: true,
  use: 'list'
});
UIDropdown.displayName = 'UIDropdown';

var _default = (0, _Controllable.default)(UIDropdown, ['open']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/dropdown/UIDropdown.js
// module id = 387
// module chunks = 209 210 211 212